import { isEmpty, trim, truncate } from 'lodash';

export function concat(arrayOfStrings, withString = ',') {
  if (arrayOfStrings instanceof Array) {
    return arrayOfStrings.map(trim)
                         .filter(s => !isEmpty(s))
                         .join(withString);
  }

  return '';
}

export function maxLength(str, length = 50, omission = '') {
  if (str && typeof str === 'string') {
    return truncate(str, {length, omission});
  }

  return str;
}

export function isNumeric(str) {
  return !isNaN(str);
}



// WEBPACK FOOTER //
// ./shared/lib/strings.js